import React from 'react';
import {useTranslation} from 'react-i18next';

import {CollapsibleSection} from 'src/components';
import {CenterRow} from 'src/components/primitives';
import {CHANNEL_TYPE} from 'src/constants';
import {useGetTenantDataQuery} from 'src/containers/User';

import * as S from '../Modals/style';
import {TariffTemplateDescription} from '../TariffTemplateDescription';
import {TTariffTemplate} from '../definitions';
import {getTariffName} from '../utils';

type TTariffTemplatesListProps = {
  tariffs: TTariffTemplate[];
};

const TariffTemplatesList = React.memo<TTariffTemplatesListProps>(({tariffs}) => {
  const {t} = useTranslation();

  const {data: tenantData} = useGetTenantDataQuery();

  const needAgreementConfirmation = !!tenantData?.needAgreementConfirmation;

  return (
    <>
      {tariffs?.map((tariff) => (
        <CollapsibleSection
          key={tariff.id}
          size="L"
          label={
            <CenterRow>
              <S.Subject type={tariff.channelType} name={CHANNEL_TYPE[tariff.channelType]} />
              {getTariffName(t, tariff)}
            </CenterRow>
          }
        >
          <S.Description>
            <TariffTemplateDescription
              tariff={tariff}
              needAgreementConfirmation={needAgreementConfirmation}
              currency={tariff.currency}
            />
          </S.Description>
        </CollapsibleSection>
      ))}
    </>
  );
});

TariffTemplatesList.displayName = 'TariffTemplatesList';

export default TariffTemplatesList;
